import React from "react";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";
import { isWebpSupported } from "react-image-webp/dist/utils";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getCookie } from "../../components/Cookie";
import MetaTags from "react-meta-tags";

import axios from "axios";

import loadable from "@loadable/component";

// import logo from './../../logo.svg';

import Section from "../../components/blocks/Section";
import MultiService from "../../components/blocks/MultiService";

//import Quote from '../../components/blocks/Quote';

import Why from "../../components/ready/Why";

import Shadow from "../../components/texting/Shadow";

import Intro from "../../layouts/intro";

//import chair from '../../images/multiservices/chair.png';

import personage from "../../images/personajes/video.png";
import personage_webp from "../../images/personajes/video.webp";
import personage_webp_mobile from "../../images/personajes/video-mobile.webp";

import personage2 from "../../images/personajes/quote.png";
import personage2_webp from "../../images/personajes/quote.webp";

import clapper from "../../images/clapper.png";
import clapper_webp from "../../images/clapper.webp";

import ArticlesSlider from "../../components/ready/ArticlesSlider";

import Modal from "../../components/blocks/Modal";

import client1 from "../../images/clients/videoproduction/1.png";
import client2 from "../../images/clients/videoproduction/2.png";
import client3 from "../../images/clients/videoproduction/3.png";

import client5 from "../../images/clients/videoproduction/5.png";

import client7 from "../../images/clients/videoproduction/7.png";
import client8 from "../../images/clients/videoproduction/8.png";
import client9 from "../../images/clients/videoproduction/9.png";

import client14 from "../../images/clients/videoproduction/14.png";

import "./videoProduction.css";

const Quote = loadable(() => import("../../components/blocks/Quote"));

class VideoProduction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: null,
      showModal: false,
      loaded: false,
      showModal2: false,
    };

    this.scrollTo = this.scrollTo.bind(this);

    this.startQuote = this.startQuote.bind(this);

    this.hideModal = this.hideModal.bind(this);

    this.hideModal2 = this.hideModal2.bind(this);

    this.onSubmit = this.onSubmit.bind(this);
  }

  scrollTo(to, duration) {
    this.setState({ active: to });

    scroller.scrollTo(to, {
      duration: duration,
      delay: 250,
      smooth: "easeOutQuad",
    });
  }

  hideModal() {
    this.setState({ showModal: false });
  }
  hideModal2() {
    this.setState({ showModal2: false });
  }

  startQuote() {
    if (window.innerWidth > 1000) {
      this.setState({ showModal: true });
    }
  }

  onSubmit(e, styles, duration, script, voiceover, textarea, textarea2) {
    e.preventDefault();

    const formData = new FormData();

    var fields = ["name", "email", "number", "country"];

    for (let i = 0; i < fields.length; i++) {
      if (document.querySelector('input[name="' + fields[i] + '"]').value) {
        formData.append(
          fields[i],
          document.querySelector('input[name="' + fields[i] + '"]').value
        );
      }
    }

    if (document.querySelector('textarea[name="note"]').value) {
      formData.append(
        "note",
        document.querySelector('textarea[name="note"]').value
      );
    }

    if (styles === "Other") {
      formData.append("styles", "(Other)" + textarea);
    } else {
      formData.append("styles", styles);
    }

    if (duration === "Other") {
      formData.append("duration", "(Other)" + textarea2);
    } else {
      formData.append("duration", duration);
    }

    formData.append("script", script);

    formData.append("voiceover", voiceover);

    var that = this;

    this.setState({ showModal: false });

    this.setState({ showModal2: true });

    axios
      .post("https://mailer.weprodigi.com/api/v1/video-quote", formData)
      .then((response) => {
        that.setState({ loaded: true });
      });
    // axios.post("https://mailer.weprodigi.com/api/v1/video-landings", formData).then(response => {

    //   that.setState({loaded:true});

    // });
  }

  render() {
    var d3_video = "https://weprodigi.com/videos/3d.mp4";

    var d3_poster = "https://weprodigi.com/posters/3d.jpg";

    switch (this.props.country) {
      case "US":
      case "GB":
      case "CA":
      case "DE":
      case "AU":
      case "SE":
      case "KR":
      case "NZ":
      case "QA":
      case "SG":
      case "BS":
      case "LU":
      case "KN":
      case "KW":
        d3_video = "https://weprodigi.com/videos/new_3d.mp4";

        d3_poster = "https://weprodigi.com/posters/new_3d.jpg";

        break;
    }

    console.log(this.props.country);

    return (
      <div className="multiservices-page video-production">
        <MetaTags>
          <title>
            Digital Video Production Services | Animation Company - Prodigi
          </title>
          <meta
            name="description"
            content="Fully customised explainer, animation, promotional, social media videos for your brand.  We have  2D and 3D animation, video editing solutions for your existing or upcoming projects. "
          />
        </MetaTags>

        <Intro
          personage={personage}
          personage_webp={
            window.innerWidth <= 420 ? personage_webp_mobile : personage_webp
          }
          background="intro intro-services"
          animations={
            <div class="cont">
              <div class="personage-overlay"></div>
              <div class="glitch-container">
                <div class="img">
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                  <div class="glitch-line"></div>
                </div>
              </div>
            </div>
          }
          desktop={{
            1: { type: "title", value: "Video" },
            2: { type: "subtitle", value: "Production" },
            3: {
              type: "button",
              value: (
                <a className="calculate-button" onClick={this.startQuote}>
                  <span className="icon icon-calculator"></span>Calculate Price
                </a>
              ),
            },
          }}
          mobile={{
            1: {
              type: "subtitle",
              value: "Video",
              fontSize: "10.5vw",
              lineHeight: "17vw",
            },
            2: {
              type: "subtitle",
              value: "Production",
              fontSize: "10.5vw",
              lineHeight: "17vw",
            },
          }}
        >
          <div
            className="services"
            style={window.innerWidth < 1000 ? { display: "none" } : {}}
          >
            <div
              className={
                "service" +
                (this.state.active === "explainer-videos" ? " active" : "")
              }
              onClick={() => this.scrollTo("explainer-videos", 950)}
            >
              Explainer Videos
            </div>

            <div
              className={
                "service" +
                (this.state.active === "whiteboard-videos" ? " active" : "")
              }
              onClick={() => this.scrollTo("whiteboard-videos", 1400)}
            >
              2D Animated Videos
            </div>
            <div
              className={
                "service" +
                (this.state.active === "d3-animated-videos" ? " active" : "")
              }
              onClick={() => this.scrollTo("d3-animated-videos", 1400)}
            >
              3D Animated Videos
            </div>

            <div
              className={
                "service" +
                (this.state.active === "social-media-videos" ? " active" : "")
              }
              onClick={() => this.scrollTo("social-media-videos", 700)}
            >
              Social Media<br></br>Videos
            </div>

            <div
              className={
                "service" +
                (this.state.active === "promotional-videos" ? " active" : "")
              }
              onClick={() => this.scrollTo("promotional-videos", 1100)}
            >
              Whiteboard Videos
            </div>
            <div
              className={
                "service" +
                (this.state.active === "videos-for-site" ? " active" : "")
              }
              onClick={() => this.scrollTo("videos-for-site", 1250)}
            >
              E-Commerce Videos
            </div>
          </div>
        </Intro>

        <Section
          color={window.innerWidth > 1000 ? "white" : "white"}
          layout="container"
          id="engagement-section"
        >
          <Shadow className="engagement-shadow">Video</Shadow>

          <p className="engagement-title">
            We offer video production services for companies from various
            industries to fulfill their business needs such as marketing, sales,
            education, HR, project management, customer support, as well as for
            non-profit organizations working in the field of education,
            entertainment, and so on. With our help, you can find any type and
            style of video solutions. We are specialized in producing Explainer,
            How-to, Educational, Commercial, Product Videos, Social Media
            Videos, Webinars, Vlog Videos. You will be offered assistance in
            creating both live-action (shooting, video editing, mixed media),
            and animation style videos by offering 2D and 3D, Whiteboard, Motion
            Infographics animation services.
          </p>

          <Link className="calculate-button d-md-none" to="/quote">
            <span className="icon icon-calculator"></span>Calculate Price
          </Link>
        </Section>

        <Section
          color="gray"
          background="multiservices"
          layout="container-fluid p-0"
          id="multiservices-section"
        >
          <MultiService
            id="explainer-videos"
            title={
              <span>
                Explainer <br></br>Videos
              </span>
            }
            titleNode="Explainer Video"
            about="Explainer videos are a perfect match for businesses introducing themselves, new products, and their features to the market. This format will work for any type of business and industry but is most widespread in fields where concepts are challenging to explain. IT, healthcare, engineering to name a few of the industries. The format is also effective for internal company use as training materials or introduction to new company guidelines. <br> Our in-house team members produce specially targeted and uniquely branded videos, thus differentiating us from the rest of the crowd. We have partnered up with companies representing Fortune 500 such as Audi, Pepsi, KFC, and Pizza Hut. Besides our expertise includes working with engineering, education, healthcare, IT, freight transportation and we are open to expanding our partnership with you! The complete satisfaction and success of our clients rely on project revision at any stage without an extra fee.<br>The length and style are completely dependent on your business and target audience. Our research team will suggest whether to choose 2D or 3D animation, Motion Graphics, Whiteboard animation, Demo Screencast, or even Live-action videos. Our scriptwriters will create narration and a story that catches the attention of your desired audience. We are ready for the next challenge and for the next satisfied partner.<br>If this is the format that suits you, what are you waiting for?"
            order={{
              columns: 2,
              content: [
                "45sec Duration",
                "Scriptwriting",
                "Storyboard",
                "Character Creation & Illustrations",
                "Voiceover",
                "Background Music",
                "Unlimited Revisions",
                "Payment with milestones",
                "24/7 availability",
              ],
            }}
            // preview={{
            //   url:'https://weprodigi.com/videos/Explainer.mp4',
            //   poster:'https://weprodigi.com/posters/explainer2.jpg'
            // }}
            preview={{
              url: "https://weprodigi.com/videos/Explainer-3.mp4",
              poster: "https://weprodigi.com/posters/explainer-2.jpg",
            }}
            preview_type="video"
            preview_aspect={{
              type: "ratio",
              num: "16-9",
            }}
            price={{
              usd: "$1200",
              eur: "950€",
              gbp: "1000£",
              aud: "1600 AUD",
              sgd: "1600 SGD",
              cad: "1550 CAD",
              rub: "90000 ₽",
            }}
            price_title="Price"
            actionButton={true}
            actionButtonText="View Our Works"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG"
            currency={this.props.currency}
            icon="icon-video icon-video-1"
            badge={true}
            country={this.props.country}
            quote={{
              text: "Order Now",
            }}
          ></MultiService>

          <MultiService
            id="whiteboard-videos"
            title={
              <span>
                2D Animated<br></br>Videos
              </span>
            }
            titleNode="2D Animated Video"
            about="There is a reason why 2D animation videos are one of the most popular types requested from video production companies worldwide. From small businesses to large multinational companies, 2D animations will effectively target your audience and send the message you want them to hear. <br>The two factors determining the number of viewers are the technical aspects of video production and the creative aspects. Our experts attend numerous creative masterclasses, such as Cannes Lions and Ogilvy, on a regular basis. The abilities they acquire are beneficial to the artistic development process. Our members are well-versed in the most up-to-date programs and software for the most impressive 2D animation videos. And, another benefit you could receive from us is you could notice that most of the production companies request additional charges for each revision during the projects. What differentiates us from others is that you will avoid the additional charges for revisions. <br>The major benefit of 2D animation is being highly customizable. Do you have brand-specific fonts, designs, color palettes, or a mascot? Including them in the animation will ensure that your audience never confuses your brand with the rest of the crowd. Another benefit is that animations do not require actors, a camera crew, or a place to shoot. The remaining processes like research, script, storyboard, voiceover, design, and animation will be managed by our skilled team members to ensure the perfect end result for you. <br>Our animators would be happy to create animations of your liking. So rest assured that working with us will be a pleasure. Let's start discussing the project today!"
            order={{
              columns: 2,
              content: [
                "45sec Duration",
                "Scriptwriting",
                "Hand Drawn Storyboard",
                "Illustrations",
                "Background Music",
                "Unlimited Revisions",
                "Payment with milestones",
                "24/7 availability",
              ],
            }}
            preview={{
              url: "https://weprodigi.com/videos/finger.mp4",
              poster: "https://weprodigi.com/posters/finger.jpg",
            }}
            preview_type="video"
            preview_aspect={{
              type: "ratio",
              num: "16-9",
            }}
            price={{
              usd: "$900",
              eur: "750€",
              gbp: "800£",
              aud: "1200 AUD",
              sgd: "1200 SGD",
              cad: "1150 CAD",
              rub: "67000 ₽",
            }}
            price_title="Price"
            currency={this.props.currency}
            actionButton={true}
            actionButtonText="View Our Works"
            actionButtonLink="https://youtube.com/playlist?list=PLHJMKI8WX4RaWq8BV3GfDZT3C5cDrUtPm"
            icon="icon-video icon-video-2"
            country={this.props.country}
            quote={{
              text: "Order Now",
            }}
          ></MultiService>

          <MultiService
            id="d3-animated-videos"
            title={
              <span>
                3D Animated<br></br>Videos
              </span>
            }
            titleNode="3D Animated Video"
            about="3D animation is one of the better solutions if you have a physical product that needs to be shown in detail or when you want to bring a 2D animation to the next level․ It can also be used to showcase product exploitation or explain complex topics. It's also possible to give a video for a SaaS business the extra charm to please investors or clients.<br>Since 2011 we have accumulated experience of 3D animations created for different industries, from simple products to descriptions of complex nanotechnological processes. In ProDigi we have assembled a group of a-list 3D specialists with an assortment of skills in modeling, texturing, lighting, rendering, and animating. We transform your blueprint & drawing into a stunning 3D animation video that you can use in TV advertisements or for offline presentations, whether it's a  Solidworks / CAD design or just a sketch.<br>According to FORBES, the typical user will spend 88% more time on a site with 3D animated content. 3D animation may seem expensive, but this investment will yield into a video that is slick, catchy, and can accomplish things that flat images simply cannot do. We combine 3D animation and marketing strategy to assist our clients to achieve their goals. Feel free to get in touch to discuss the details"
            order={{
              columns: 2,
              content: [
                "45sec Duration",
                "Scriptwriting",
                "Hand Drawn Storyboard",
                "Illustrations",
                "Background Music",
                "Unlimited Revisions",
                "Payment with milestones",
                "24/7 availability",
              ],
            }}
            preview={{
              url: d3_video,
              poster: d3_poster,
            }}
            preview_type="video"
            preview_aspect={{
              type: "ratio",
              num: "16-9",
            }}
            price={{
              usd: "$2800",
              eur: "2300€",
              gbp: "2400£",
              aud: "2700 AUD",
              sgd: "3700 SGD",
              cad: "3600 CAD",
              rub: "209000 ₽",
            }}
            price_title="Price"
            currency={this.props.currency}
            actionButton={true}
            actionButtonText="View Our Works"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RZt-JywR44mbvtkiWz4Ktcl&fbclid=IwAR2VrxfE85adqjpV8b4aKJtqqehSeFR3EqiP9crmWmyYu_Sk0aIj9WvOJD4"
            icon="icon-video icon-video-3"
            country={this.props.country}
            quote={{
              text: "Order Now",
            }}
          ></MultiService>

          <MultiService
            id="social-media-videos"
            title={
              <span>
                Social <br></br>Media Videos
              </span>
            }
            titleNode="Social Media Video"
            about="Social Media videos are the go-to solution for small businesses of any industry, as they allow you to show the benefits of the service/product and increase the organic reach of social media in networks all on tight budgets. <br>Why are we a good fit for cooperation? Unlike other production companies, we also specialize in social media marketing and merge marketing skills and technologies into each video. According to Facebook Analytics and SocialBakers, the social media videos we create for various industries increase the viewership by an average of  65%.<br>As claimed by Harvard Business Review, 78% of users admit that their buying decisions had been influenced by social media videos. This is why our experts take the different colors, fonts, music, flexible style, and brand design tools as vital variables to optimize your content for Youtube, Instagram, Facebook, or any other platform. <br>Step on the path of success of your business by cooperating with us․"
            order={{
              columns: 2,
              content: [
                "45sec Duration",
                "Buyer Persona Analysis",
                "High Resolution File",
                "Video resizing according to each social media requirements",
                "A/B testing",
                "Social Media Ads FreeConsultation",
                "Stock Videos & Photos(Videoblocks, AdobeStock,Gettyimages, Freepik Premium)",
                "Unlimited Revisions",
                "Payment with milestones",
                "24/7 availability",
              ],
              gift: "+Gift 3 social media image design",
            }}
            preview={{
              url: "https://weprodigi.com/videos/sm_video.mp4",
              poster: "https://weprodigi.com/posters/sm_video.jpg",
            }}
            preview_type="video"
            preview_aspect={{
              type: "ratio",
              num: "16-9",
            }}
            price={{
              usd: "$550",
              eur: "500€",
              gbp: "500£",
              aud: "750 AUD",
              sgd: "750 SGD",
              cad: "700 CAD",
              rub: "40000₽",
            }}
            price_title="Price"
            currency={this.props.currency}
            actionButton={true}
            actionButtonText="View Our Works"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RZB7_bFcEx90upDyxBdRu1Z"
            icon="icon-video icon-video-4"
            badge={true}
            country={this.props.country}
            quote={{
              text: "Order Now",
            }}
          ></MultiService>

          <MultiService
            id="promotional-videos"
            title={
              <span>
                Whiteboard <br></br>Videos
              </span>
            }
            titleNode="Whiteboard Video"
            about="The Education and IT industries are two of the largest users of whiteboard videos because it allows them to quickly and efficiently explain what their services do and how they can help their customers without having to give a long presentation or skipping important details.<br>The effectiveness of whiteboard animation depends on whether it is dynamic, creative, and eye-catching. That's why we create whiteboard videos in a fully custom version, where our illustrators hand-draw everything from characters to simple items, without the use of Doodly or other similar tools, which make the video look cheap and bore the viewer.<br>Whiteboard animation videos are a great way to lead your customers to a call to action. These animations are a great way to spice up your website, social media, or email newsletters. The marketing possibilities are virtually limitless thanks to digital versatility! What you need is an idea to get started. The rest you can rest on us! "
            order={{
              columns: 2,
              content: [
                "45sec Duration",
                "Scriptwriting",
                "Storyboard",
                "Design",
                "Voiceover",
                "Sound Design",
                "Unlimited Revisions",
                "Payment with milestones",
                "24/7 availability",
              ],
            }}
            preview={{
              url: "https://weprodigi.com/videos/whiteboard.mp4",
              poster: "https://weprodigi.com/posters/whiteboard.jpg",
            }}
            preview_type="video"
            preview_aspect={{
              type: "ratio",
              num: "16-9",
            }}
            price={{
              usd: "$1200",
              eur: "950€",
              gbp: "1000£",
              aud: "1600 AUD",
              sgd: "1600 SGD",
              cad: "1550 CAD",
              rub: "90000 ₽",
            }}
            price_title="Price"
            currency={this.props.currency}
            actionButton={true}
            actionButtonText="View Our Works"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RZSc55117EMYSsvuKG4cvrS"
            icon="icon-video icon-video-5"
            country={this.props.country}
            quote={{
              text: "Order Now",
            }}
          ></MultiService>

          <MultiService
            id="videos-for-site"
            title={
              <span>
                E-Commerce<br></br>Videos
              </span>
            }
            titleNode="E-Commerce Video"
            about="eCommerce videos are a great addition to the digital marketing toolkit. Shoppers can gain product awareness and trust by watching eCommerce product videos.<br>According to Videonomics “Consumers are 64% to 85% more likely to purchase after watching a product video online”.  That's why we use eCommerce videos to increase revenue conversions for our customers. What we do is take a deep dive into knowing your customer's buying experience.<br>We are proud partners of Amazon vendors for over 4 years. Our latest video on Amazon eBooks helped our partner sell 1,200 books in two months, increasing sales by 70% over the previous year. We have complete flexible video packages that include scriptwriting, full-service video editing, and marketing optimization.<br>Drive sales up by effectively communicating with your customers with these shiny eCommerce videos, which no eye can miss!"
            order={{
              columns: 2,
              content: [
                "45sec Duration",
                "Competitive Analysis",
                "Marketing copy for the video",
                "Video resizing according to ads requirements",
                "A/B testing for the first 3 sec",
                "Stock Videos & Photos (Videoblocks,AdobeStock, Gettyimages, Freepik Premium)",
                "Unlimited Revisions",
                "Payment with milestones",
                "24/7 availability",
              ],
            }}
            preview={{
              url: "https://weprodigi.com/videos/dropshipping.mp4",
              poster: "https://weprodigi.com/posters/dropshipping.jpg",
            }}
            preview_type="video"
            preview_aspect={{
              type: "ratio",
              num: "16-9",
            }}
            price={{
              usd: "$550",
              eur: "500€",
              gbp: "500£",
              aud: "750 AUD",
              sgd: "750 SGD",
              cad: "700 CAD",
              rub: "40000 ₽",
            }}
            price_title="Price"
            currency={this.props.currency}
            actionButton={true}
            actionButtonText="View Our Works"
            actionButtonLink="https://www.youtube.com/playlist?list=PLHJMKI8WX4RZwuqLuTKoHyD21b_LpOpZv"
            icon="icon-video icon-video-6"
            country={this.props.country}
            quote={{
              text: "Order Now",
            }}
          ></MultiService>
        </Section>

        <Section id="custom-clients" layout="container" color="gray">
          <div className="clients-wrapper">
            <span className="clients-title">OUR CLIENTS</span>

            <div className="clients-container">
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/watch?v=AFR2vMGkOoA&list=PLHJMKI8WX4RaA_dvp03T9t_M9E-onhg8y&index=7&ab_channel=ProDigiDigitalAgency"
                  target="_blank"
                >
                  <LazyLoadImage src={client1} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/watch?v=MNMGDhgHOuU&list=PLHJMKI8WX4RaA_dvp03T9t_M9E-onhg8y&index=8&ab_channel=ProDigiDigitalAgency"
                  target="_blank"
                >
                  <LazyLoadImage src={client2} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/watch?v=pfLR4Of8wA0&list=PLHJMKI8WX4RaA_dvp03T9t_M9E-onhg8y&index=2&ab_channel=ProDigiDigitalAgency"
                  target="_blank"
                >
                  <LazyLoadImage src={client3} alt=""></LazyLoadImage>
                </a>
              </div>
              {/* <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/22" target="_blank">
                  <LazyLoadImage src={client4} alt=""></LazyLoadImage>
                </a>
              </div> */}
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://weprodigi.com/case/19"
                  target="_blank"
                >
                  <LazyLoadImage src={client5} alt=""></LazyLoadImage>
                </a>
              </div>
              {/* <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/10" target="_blank">
                  <LazyLoadImage src={client6} alt=""></LazyLoadImage>
                </a>
              </div> */}
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/watch?v=6s-t27GvpHo&list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG&index=4"
                  target="_blank"
                >
                  <LazyLoadImage src={client7} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://weprodigi.com/case/15"
                  target="_blank"
                >
                  <LazyLoadImage src={client8} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://weprodigi.com/case/29"
                  target="_blank"
                >
                  <LazyLoadImage src={client9} alt=""></LazyLoadImage>
                </a>
              </div>
              {/* <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/3" target="_blank">
                  <LazyLoadImage src={client10} alt=""></LazyLoadImage>
                </a>
              </div> */}
              {/* <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/18" target="_blank">
                  <LazyLoadImage src={client11} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/4" target="_blank">
                  <LazyLoadImage src={client12} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/5" target="_blank">
                  <LazyLoadImage src={client13} alt=""></LazyLoadImage>
                </a>
              </div> */}
              <div className="client">
                <a
                  rel="noopener noreferrer"
                  href="https://weprodigi.com/case/1"
                  target="_blank"
                >
                  <LazyLoadImage src={client14} alt=""></LazyLoadImage>
                </a>
              </div>
              {/* <div className="client">
                <a rel="noopener noreferrer" href="https://www.youtube.com/watch?v=IOm_RdiHYRU&ab_channel=ProDigiDigitalAgency" target="_blank">
                  <LazyLoadImage src={client15} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://www.youtube.com/watch?v=XwxZ2vfmSR0&ab_channel=ProDigiDigitalAgency" target="_blank">
                  <LazyLoadImage src={client16} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/20" target="_blank">
                  <LazyLoadImage src={client17} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/26" target="_blank">
                  <LazyLoadImage src={client18} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/cases" target="_blank">
                  <LazyLoadImage src={client19} alt=""></LazyLoadImage>
                </a>
              </div>
              <div className="client">
                <a rel="noopener noreferrer" href="https://weprodigi.com/case/13" target="_blank">
                  <LazyLoadImage src={client20} alt=""></LazyLoadImage>
                </a>
              </div> */}
            </div>
          </div>
        </Section>

        <Section
          color={window.innerWidth > 1000 ? "white" : "white"}
          layout="container-fluid"
          id="quote-part"
        >
          <p className="quote-title">
            calculate your <span>video cost</span>
          </p>

          <p className="quote-subtitle">
            Answer five questions and get to know the price!
          </p>

          <div className="row">
            <LazyLoadImage
              src={isWebpSupported() ? personage2_webp : personage2}
              className="personage"
              alt=""
            ></LazyLoadImage>

            <LazyLoadImage
              src={isWebpSupported() ? clapper_webp : clapper}
              className="clapper"
              alt=""
            ></LazyLoadImage>
          </div>

          <div className="rect"></div>
          <div className="rect2"></div>

          <div className="matrix"></div>

          {window.innerWidth > 1000 ? (
            <a className="button" onClick={this.startQuote}>
              Start Now
            </a>
          ) : (
            <Link className="button" to="/quote">
              Start Now
            </Link>
          )}
        </Section>

        {!(
          getCookie("weprodigi-pro") ||
          window.location.search.indexOf("pro") > -1
        ) && (
          <Section
            color={window.innerWidth > 1000 ? "white" : "gray"}
            layout="container"
            id="why"
          >
            <p className="why-header">Why</p>

            <Why
              content={[
                {
                  title: "We value your time",
                  answer:
                    "We know how important our clients’ time & management resources are, and outsourcing video production should help save time, not waste it, as time is more expensive. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title:
                    "We include digital marketing specialists in the production process",
                  answer:
                    "According to Google, 6 out of 10 people are keener on watching videos online rather than TV. To create an effective video, you need to consider on which platform the video will be used and master all the features of it, be it your website, Youtube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each of the online platforms to get effective material in the end result.",
                },
                {
                  title: "we don’t require prepayment",
                  answer:
                    "We believe that the client should pay for the done work, rather than with deposits. We choose a milestone payment option, as we believe that it's a more trustworthy approach in our work.",
                },
                {
                  title: "we don’t have a single unhappy client",
                  answer:
                    "We never charge for a product that is not approved by you. You’ll never experience that here at ProDigi. If you are not satisfied with the results, your 100% money-back is guaranteed.",
                },
              ]}
            ></Why>
          </Section>
        )}

        <Section
          color={window.innerWidth > 1000 ? "gray" : "white"}
          layout="container"
          id="articles"
        >
          <ArticlesSlider></ArticlesSlider>
        </Section>

        {/* <Section color="white">

            <div className="row align-items-center intro-row">
                <div className="col-lg-5 d-none d-lg-block">
                    <img src={chair} alt=""></img>
                </div>
                <div className="col-lg-7 text-left">
                    <p className="lights">Lights! Camera! Action!</p>
                    <img style={{width:'100%'}} className="d-lg-none" src={chair} alt=""></img>
                    <p className="lights-desc">If you can think it, we can create it. Let’s create amazing video content together and convert your viewers into clients. Have an idea in mind?</p>
                    <Link className="button lights-button" to="/contact-us">Contact Us</Link>
                </div>
            </div>

      </Section> */}

        <Quote
          country={this.props.country}
          show={this.state.showModal}
          hide={this.hideModal}
          submit={this.onSubmit}
        ></Quote>

        <Modal
          show={this.state.showModal2}
          hide={this.hideModal2}
          loaded={this.state.loaded}
          version="quote"
        ></Modal>
      </div>
    );
  }
}

export default VideoProduction;
